import { ReactElement } from 'react';
import cn from 'classnames';

import styles from './SelectVariantButton.module.scss';
import config from '../../config.json';
import cms from '../../data/cms.json';
import { useKeyboardClick } from '../../hooks/useKeyboardClick';
import { Icon } from '../Icon/Icon';
import { getDataTest } from '../../utils/dataTests';

export interface SelectVariantButtonProps {
    checked: boolean;
    price: string;
    onPositiveClick: () => void;
    onNegativeClick: () => void;
    className?: string;
    disabled?: boolean;
}

export const SelectVariantButton = ({
    checked,
    price,
    className,
    onPositiveClick,
    onNegativeClick,
    disabled,
    ...props
}: SelectVariantButtonProps): ReactElement | null => {
    const handlePositiveKeyDown = useKeyboardClick(onPositiveClick);
    const handleNegativeKeyDown = useKeyboardClick(onNegativeClick);

    return (
        <div
            className={cn(styles.wrapper, disabled && styles.disabled, checked && styles.checked, className)}
            {...props}
        >
            <div
                className={cn(styles.positiveToggler, styles.toggler, checked && styles.positiveTogglerActive)}
                role="button"
                tabIndex={0}
                onClick={onPositiveClick}
                onKeyDown={handlePositiveKeyDown}
                data-test={getDataTest(props, 'Positive')}
            >
                <div className={styles.price}>
                    <Icon name="checked" />
                    {price} {config.CURRENCIES.CZK}
                </div>
            </div>

            <div
                className={cn(styles.negativeToggler, styles.toggler, !checked && styles.negativeTogglerActive)}
                role="button"
                tabIndex={0}
                onClick={onNegativeClick}
                onKeyDown={handleNegativeKeyDown}
                data-test={getDataTest(props, 'Negative')}
            >
                {cms.common.notInterestedButton}
            </div>
        </div>
    );
};
